import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "error-container"
}
const _hoisted_4 = {
  key: 2,
  class: "content-container"
}
const _hoisted_5 = {
  key: 0,
  class: "productDetail_one"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 3,
  class: "empty-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "loading-spinner" }, null, -1),
          _createElementVNode("p", null, "加载中...", -1)
        ]))]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, "加载失败：" + _toDisplayString(_ctx.error), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fetchDetailData && _ctx.fetchDetailData(...args))),
              class: "retry-button"
            }, "重试")
          ]))
        : (_ctx.detailData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.validImageUrls.length >= 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validImageUrls, (url, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `detail-${index}`
                      }, [
                        (_ctx.isVideo(_ctx.trimImageUrl(url)))
                          ? (_openBlock(), _createElementBlock("video", {
                              key: 0,
                              src: _ctx.trimImageUrl(url),
                              autoplay: "",
                              muted: "",
                              loop: "",
                              playsinline: ""
                            }, null, 8, _hoisted_6))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.trimImageUrl(url),
                              alt: `Detail Image ${index + 1}`
                            }, null, 8, _hoisted_7))
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("p", null, "暂无数据", -1)
            ]))]))
  ]))
}